<template>
	<div class="lf">
		<div class="lf__elm">
			<!-- ////////////////// -->
			<!-- LABEL -->
			<div class="lf__elm-label">Введите номер телефона</div>

			<!-- ////////////////// -->
			<!-- CHANNELS -->
			<div class="lf__elm-channel" v-if="false">
				<div
					@click="redirect('tapi')"
					:class="
						serviceName === 'wapi'
							? 'lf__elm-channel-item_current'
							: 'lf__elm-channel-item'
					"
				>
					<IconWhatsApp />
					<div class="lf__elm-channel-item-label">WhatsApp</div>
				</div>
				<div
					@click="redirect('wapi')"
					:class="
						serviceName === 'tapi'
							? 'lf__elm-channel-item_current'
							: 'lf__elm-channel-item'
					"
				>
					<IconTelegram />
					<div class="lf__elm-channel-item-label">Telegram</div>
				</div>
			</div>

			<!-- ////////////////// -->
			<!-- PHONE -->
			<div class="lf__elm-phone">
				<!--				<UiPhoneNumber />-->
				<!-- INPUT -->
				<MazPhoneNumberInput
					v-model="number"
					@update="numberHandler"
					@keyup.enter="onClickGetCode"
					:translations="{
						countrySelector: {
							placeholder: 'Код страны',
						},
						phoneInput: {
							placeholder: 'Номер телефона',
							example: 'Пример:',
						},
					}"
				/>

				<!-- BUTTON -->
				<UiButton
					@click="onClickGetCode"
					class="lf__elm-phone-btn"
					label="Получить код"
					:background-color="
						isInputEmpty
							? 'rgb(244, 246, 250)'
							: 'var(--theme-color)'
					"
					:border-color="
						isInputEmpty
							? 'rgb(244, 246, 250)'
							: 'var(--theme-color)'
					"
					:color="
						isInputEmpty
							? 'rgb(188, 192, 207)'
							: 'rgb(255, 255, 255)'
					"
					font-weight="600"
					font-size="16px"
				/>
			</div>

			<!-- Уведомление об ошибке -->
			<!--
				TODO: Отпала необходимость выводить ошибку.
				Потому что, если пользователь не зарегистрирован, мы без всяких уведомлений регистрируем пользователя
				TODO: Но, пока на всякий случай оставляю блок с уведомлением.
			-->
			<!--
			<div v-if="isNotRegistered" class="lf__elm-error">
				ОШИБКА. Пользователь с таким номером телефона не
				зарегистрирован!
			</div>
			-->
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconWhatsApp from "@/components/icons/IconWhatsApp.vue";
import IconTelegram from "@/components/icons/IconTelegram.vue";
import UiButton from "@/components/ui/UiButton.vue";
import { mapActions, mapGetters } from "vuex";

import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput";

export type Results = {
	isValid: boolean;
};

@Options({
	components: {
		// UiPhoneNumber,
		UiButton,
		IconTelegram,
		IconWhatsApp,
		MazPhoneNumberInput,
	},

	computed: {
		...mapGetters("registrationModule", {
			registration: "registrationGetters",
		}),

		...mapGetters("authModule", {
			registration: "checkRegisteredGetters",
		}),
	},

	methods: {
		...mapActions("registrationModule", [
			"phoneNumberAction",
			"registrationAction",
		]),

		...mapActions("authModule", [
			"checkRegisteredAction",
			"loginGenerateConfirmationCodeAction",
		]),
	},
})
export default class LoginForm extends Vue {
	public isInputEmpty = true;
	public number = "";
	public isShowError = false;

	// ************************************************************
	// Define mapGetters
	public registration: {
		createdId: number;
		isExist: boolean;
		isIpAddr?: boolean;
	};

	// ************************************************************
	// Define mapActions
	public phoneNumberAction!: (payload: {
		phone: string;
		actionType: string;
	}) => void;

	public checkRegisteredAction!: (payload: {
		phone: string;
	}) => Promise<void>;

	public loginGenerateConfirmationCodeAction!: (payload: {
		phone: string;
	}) => Promise<void>;

	public registrationAction!: (payload: { phone: string }) => Promise<void>;

	/**
	 * Computed
	 */
	public get isNotRegistered() {
		return !this.registration.isExist && this.isShowError;
	}

	/**
	 * Hook mounted
	 */
	public async mounted() {
		// Сбрасываем значение
		this.registration.isExist = false;
		this.registration.isIpAddr = false;
		this.isShowError = false;
		// Динамическое подключение стилей для компонента MazPhoneNumberInput
		await import("../../../src/assets/phoneNumberInput/style");
	}

	/**
	 * Обработка поля ввода для номера телефона
	 * @param event
	 */
	public numberHandler(event: Results) {
		this.isInputEmpty = !event.isValid;
	}

	/**
	 * Получить код
	 */
	public async onClickGetCode() {
		if (!this.isInputEmpty) {
			const phone = this.number.replace("+", "");

			this.isShowError = false;
			// Проверяем, зарегистрирован номер или нет.
			await this.checkRegisteredAction({ phone: phone });

			if (this.registration.isExist) {
				// Номер зарегистрирован.

				// 1. Сохраняем номер телефона в store
				this.phoneNumberAction({
					phone: phone,
					actionType: "signIn",
				});

				// 2. Генерируем проверочный код
				await this.loginGenerateConfirmationCodeAction({
					phone: phone,
				});

				// 3. Переходим на страницу проверки кода
				this.$router.push({
					path: "/confirmation",
				});
			} else {
				this.isShowError = true;
				// Номер не зарегистрирован. А значит регистрируем.

				await this.registrationAction({ phone: phone });
				// Сохраняем номер телефона в store
				this.phoneNumberAction({
					phone: phone,
					actionType: "signUp",
				});

				// Код сгенерирован и добавлен в таблицу confirmation_code
				if (this.registration.createdId !== 0) {
					// Переход на страницу проверки кода
					this.$router.push({
						path: "/confirmation",
					});
				} else {
					// Для данного номера уже был сгенерирован код, а также добавлен в таблицу confirmation_code
					if (
						!this.registration.isExist &&
						!this.registration.isIpAddr
					) {
						this.$router.push({
							path: "/confirmation",
						});
					}
				}

				return;
			}
		}
	}

	/**
	 * Возвращает название сервиса (wapi или tapi)
	 */
	public get serviceName() {
		return process.env.VUE_APP_THEME;
	}

	/**
	 * Переход на другой хост (wapi или tapi)
	 * @param serviceName
	 */
	public redirect(serviceName: string) {
		if (this.serviceName === serviceName) {
			window.location.href = process.env.VUE_APP_HOST + "/login";
		}
	}
}
</script>

<style scoped lang="scss">
.lf {
	background: rgb(255, 255, 255);
	border-radius: 12px;
	box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.02);

	&__elm {
		padding: 24px;
	}

	&__elm-label {
		color: rgb(49, 49, 50);
		font-size: 16px;
	}

	&__elm-channel {
		display: flex;
		padding-top: 16px;
	}

	&__elm-channel-item {
		display: flex;
		align-items: center;
		padding: 9px 12px;
		background: rgb(255, 255, 255);
		margin-right: 10px;
		border-radius: 12px;
		cursor: pointer;
	}

	&__elm-channel-item_current {
		display: flex;
		align-items: center;
		padding: 9px 12px;
		background: rgb(244, 246, 250);
		margin-right: 10px;
		border-radius: 12px;
		cursor: pointer;
	}

	&__elm-channel-item-label {
		color: rgb(49, 49, 50);
		margin-left: 16px;
	}

	&__elm-phone {
		display: flex;
		padding-top: 16px;
		align-items: center;
	}

	&__elm-phone-input {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		border: 1px solid rgb(244, 246, 250);
		border-radius: 12px;
		padding: 12px;
		background-color: rgb(244, 246, 250);
	}

	&__elm-phone-input-num {
		background-color: rgb(244, 246, 250);
		border: 1px solid rgb(244, 246, 250);
		font-size: 16px;
		width: 90%;
		-moz-appearance: textfield;
	}

	&__elm-phone-input-num:focus {
		outline-color: rgb(244, 246, 250);
		outline-style: solid;
	}

	&__elm-phone-input-num::-webkit-outer-spin-button,
	&__elm-phone-input-num::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	&__elm-phone-btn {
		margin-left: 12px;
	}

	&__elm-error {
		padding-top: 16px;
		color: rgb(232, 57, 65);
	}

	@media screen and (max-width: 768px) {
		&__elm {
			padding: 12px;
		}
		&__elm-channel {
			justify-content: space-between;
		}

		&__elm-channel-item {
			padding: 9px 16px;
		}

		&__elm-phone {
			display: block;
		}

		&__elm-phone-btn {
			margin-top: 12px;
			margin-left: 0;
		}
	}
}
</style>
